import { render, staticRenderFns } from "./BmProducts.vue?vue&type=template&id=0af5e813&"
import script from "./BmProducts.vue?vue&type=script&lang=js&"
export * from "./BmProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports